import gql from 'graphql-tag';

const LIST_CAMPAIGNORDERS_CONNECTION = gql`
  query campaignOrdersConnection($where: CampaignOrderWhereInput!) {
    campaignOrdersConnection(where: $where) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          name
          budget
          startDate
          type
          IONumber
          advertiser {
            name
            id
            CPAcronym
            level
            parentOrg {
              id
              level
              name
              CPAcronym
              createdAt
            }
          }
          orgs {
            id
            name
          }
        }
      }
      aggregate {
        count
      }
    }
    full: campaignOrdersConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default LIST_CAMPAIGNORDERS_CONNECTION;
